export default __webpack_public_path__ + "static/media/stroke.95413c0e.svg";